import numberCustomerImage from '../images/registrations/info_version/info-mobile-01.png';
import hourSavedImage from '../images/registrations/info_version/info-mobile-02.png';
import finalistImage from '../images/registrations/info_version/info-mobile-03.png';
import effortlessImage from '../images/registrations/info_version/info-mobile-04.png';

const SlideMobileData = [
  {
    imageItem: {
      url: numberCustomerImage,
      alt: '300+ customers',
    },
    title: '300+',
    titleCss: 'firstTitle',
    description: {
      firstDes: 'Ever since 2015, Rakuna has had the honor to serve over 300 global companies',
      secondDes: undefined,
    },
  },
  {
    imageItem: {
      url: hourSavedImage,
      alt: '1400+ hours saved',
    },
    title: '1400+',
    titleCss: 'firstTitle',
    description: {
      firstDes: 'With Rakuna help, companies have been able to save 1400+ recruiting hours annually',
      secondDes: undefined,
    },
  },
  {
    imageItem: {
      url: finalistImage,
      alt: 'Finalist',
    },
    title: 'Finalist',
    titleCss: 'thirdTitle',
    description: {
      firstDes: 'Rakuna was the finalist of MN Cup 2016 - the largest statewide business competition in the U.S. with 1400+ entries',
      secondDes: undefined,
    },
  },
  {
    imageItem: {
      url: effortlessImage,
      alt: 'Effortless',
    },
    title: 'Effortless',
    titleCss: 'secondTitle',
    description: {
      firstDes: '"Rakuna" means "effortless" in Japanese',
      secondDes: undefined,
    },
  },
];

export default SlideMobileData;
